<template>
  <form @submit.prevent>
    <v-layout wrap>
      <template v-if="['create'].includes(mode)">
        <v-flex xs12 md6 class="pa-2">
          <div
            :class="{
              'form-control': true,
              'has-error': errors.first('username')
            }"
          >
            <div class="mb-2">
              {{ $t('asset_wise.username') }}
              <span class="error--text">*</span>
            </div>
            <input
              v-model="localValue.username"
              v-validate="'required'"
              type="text"
              name="username"
              autocomplete="new-password"
              :data-vv-as="$t('asset_wise.username')"
              @change="emit()"
            />
            <div v-if="errors.first('username')" class="caption error--text">
              {{ errors.first('username') }}
            </div>
          </div>
        </v-flex>
      </template>
      <template v-if="['create', 'password'].includes(mode)">
        <v-flex xs12 md6 class="pa-2">
          <div
            :class="{
              'form-control': true,
              'has-error': errors.first('password')
            }"
          >
            <div class="mb-2">
              {{ $t('password') }}
              <span class="error--text">*</span>
            </div>
            <input
              v-model="localValue.password"
              v-validate="'required'"
              type="password"
              name="password"
              autocomplete="new-password"
              :data-vv-as="$t('password')"
              @change="emit()"
            />
            <div v-if="errors.first('password')" class="caption error--text">
              {{ errors.first('password') }}
            </div>
          </div>
        </v-flex>
      </template>
      <template v-if="['create', 'edit'].includes(mode)">
        <v-flex xs12 md6 class="pa-2">
          <div
            :class="{
              'form-control': true,
              'has-error': errors.first('firstName')
            }"
          >
            <div class="mb-2">
              {{ $t('name') }}
              <span class="error--text">*</span>
            </div>
            <input
              v-model="localValue.firstName"
              v-validate="'required'"
              type="text"
              name="firstName"
              :data-vv-as="$t('name')"
              @change="emit()"
            />
            <div v-if="errors.first('firstName')" class="caption error--text">
              {{ errors.first('firstName') }}
            </div>
          </div>
        </v-flex>
        <v-flex xs12 md6 class="pa-2">
          <div
            :class="{
              'form-control': true,
              'has-error': errors.first('lastName')
            }"
          >
            <div class="mb-2">
              {{ $t('asset_wise.surname') }}
              <span class="error--text">*</span>
            </div>
            <input
              v-model="localValue.lastName"
              v-validate="'required'"
              type="text"
              name="lastName"
              :data-vv-as="$t('asset_wise.surname')"
              @change="emit()"
            />
            <div v-if="errors.first('lastName')" class="caption error--text">
              {{ errors.first('lastName') }}
            </div>
          </div>
        </v-flex>
        <v-flex xs12 md6 class="pa-2">
          <div
            :class="{
              'form-control': true,
              'has-error': errors.first('email')
            }"
          >
            <div class="mb-2">
              {{ $t('email') }}
              <span class="error--text">*</span>
            </div>
            <input
              v-model="localValue.email"
              v-validate="'required|email'"
              type="email"
              name="email"
              :data-vv-as="$t('email')"
              @change="emit()"
            />
            <div v-if="errors.first('email')" class="caption error--text">
              {{ errors.first('email') }}
            </div>
          </div>
        </v-flex>
        <v-flex xs12 md6 class="pa-2">
          <div
            :class="{
              'form-control': true,
              'has-error': errors.first('tel')
            }"
          >
            <div class="mb-2">
              {{ $t('Phone') }}
              <span class="error--text">*</span>
            </div>
            <input
              v-model="localValue.tel"
              v-validate="'required|numeric'"
              type="tel"
              name="tel"
              maxlength="10"
              :data-vv-as="$t('Phone')"
              @change="emit()"
            />
            <div v-if="errors.first('tel')" class="caption error--text">
              {{ errors.first('tel') }}
            </div>
          </div>
        </v-flex>
      </template>
    </v-layout>
  </form>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: undefined
    },
    mode: {
      type: String,
      default: 'create',
      validator: (value) => ['create', 'edit', 'password'].includes(value)
    }
  },
  data() {
    return {
      localValue: {
        username: '',
        password: '',
        firstName: '',
        lastName: '',
        email: '',
        tel: '',
        ...this.value
      }
    }
  },
  watch: {
    value(value) {
      this.localValue = { ...this.localValue, ...value }
    }
  },
  methods: {
    emit() {
      this.$emit('input', this.localValue)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/ExecutiveManagement/UserForm.vue